import React from "react";
import { Grid, Table, TableHead, TableCell, TableRow, TableBody, Tooltip } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import { Values } from "Tools/Values";
import { Location, LocationPosition } from "@src/Interfaces/Entity/Location";
import { Position } from "@src/Interfaces/Entity/Position";
import { observer, inject } from "mobx-react";
import { IValuesStore } from "@src/Stores/Values/types";
import { STWrapper, CSTPaper, CSFab, STEmptyAdd, STEmptyAddWrapper } from "./styles";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { STFormTitleTypography } from "@src/Components/Ui/STFormTitleTypohraphy";
import DeleteIcon from "@material-ui/icons/Delete";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import AddPosition from "../AddPosition/AddPosition";
import _ from "lodash";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";
import {computed} from "mobx";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  location: Location;
  values?: IValuesStore;
  management?: IManagementStore;
  noTitle?: boolean;
  auth?: IAuthStore;
}

@inject("auth", "values", "management")
@observer
export default class PositionsForm extends React.Component<IProps> {
  @computed get adminPositionId() {
    return this.props.values?.common["AdminPositionId"];
  }
  getPositions(): Position[] {
    let items = _(this.props.location.locationPositions || [])
      .filter(position =>
        _.some(
          this.props.management.activePositions,
          x => x.id == position.positionId && position.state === this.props.values.states.Active
        )
      )
      .map(position => this.props.management.activePositions.find(x => x.id == position.positionId))
      .orderBy(position => position.name)
      .value();
    return items;
  }

  removePosition = (positionId: string): void => {
    this.props.location.locationPositions = this.props.location.locationPositions.map(position => {
      if (position.positionId !== positionId) {
        return position;
      }
      position.state = this.props.values.states.Deactivated;
      return position;
    });
    this.triggerRender();
  };

  onAdd = (positionId: string) => {
    if (_.isNil(this.props.location.locationPositions)) {
      this.props.location.locationPositions = [];
    }
    if (this.props.location.locationPositions.filter(position => position.positionId === positionId).length === 0) {
      this.props.location.locationPositions.push(new LocationPosition(positionId, this.props.values.states.Active));
    } else {
      this.props.location.locationPositions = this.props.location.locationPositions.map(position => {
        if (position.positionId !== positionId) {
          return position;
        }
        position.state = this.props.values.states.Active;
        return position;
      });
    }
    this.triggerRender();
  };

  triggerRender() {
    this.forceUpdate();
  }

  render() {
    let positions = this.getPositions();
    let canEdit = this.props.auth.user.location.primary;
    return (
      <STWrapper>
        {!this.props.noTitle && (
          <Grid container>
            <Grid item xs>
              <STFormTitleTypography>{Values.getLocalizationValue("positionManagement")}</STFormTitleTypography>
            </Grid>
            <Grid item>
              <STFormTitleTypography>{this.props.location.name}</STFormTitleTypography>
            </Grid>
          </Grid>
        )}
        {positions.length === 0 && (
          <STEmptyAdd>
            <STEmptyAddWrapper>
              {canEdit && <AddPosition locationPositions={this.props.location.locationPositions} onAdd={this.onAdd} />}
            </STEmptyAddWrapper>
            <ResultsAreEmpty />
          </STEmptyAdd>
        )}
        {positions.length > 0 && (
          <CSTPaper elevation={2}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell size="small">
                    <STTableHeadTypography>{Values.getLocalizationValue("title")}</STTableHeadTypography>
                  </TableCell>
                  <TableCell size="small">
                    <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
                  </TableCell>
                  <TableCell size="small">
                    <STTableHeadTypography>{Values.getLocalizationValue("description")}</STTableHeadTypography>
                  </TableCell>
                  <TableCell align="right" size="small">
                    {canEdit && (
                      <AddPosition locationPositions={this.props.location.locationPositions} onAdd={this.onAdd} />
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {positions.map(position => {
                  return (
                    <TableRow className={"management-table-row"} hover key={position.id}>
                      <TableCell size="small">
                        <STTableCellTypography>{position.title}</STTableCellTypography>
                      </TableCell>
                      <TableCell size="small">
                        <STTableCellTypography>{position.name}</STTableCellTypography>
                      </TableCell>
                      <TableCell size="small">
                        <STTableCellTypography>{position.description}</STTableCellTypography>
                      </TableCell>
                      <TableCell align="right" size="small">
                        {canEdit && position.id != this.adminPositionId && (
                            <RoundButton
                                icon={<DeleteIcon/>}
                                tooltipTitle={Values.getLocalizationValue("edit")}
                                onClick={() => this.removePosition(position.id)}
                                color={"red"}
                            />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </CSTPaper>
        )}
      </STWrapper>
    );
  }
}
